import { fun_PostAction } from "@/api";
import FormConfig from "../formConfig.js";
import {Loading} from "_element-ui@2.15.14@element-ui";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 查询表单绑定值
      form: {
        id: null, // 主键
        contractRecordDirectlyId: null, // 直接发包备案表主键
        duty: null, // 职务
        name: null, // 姓名
        positionalTitles: null, // 职称
        certificateName: null, // 证书名称
        level: null, // 级别
        number: null, // 证号
        professional: null, // 专业
      },
      // 表单错误提示
      errRules: {
        id: null, // 主键
        contractRecordDirectlyId: null, // 直接发包备案表主键
        duty: null, // 职务
        name: null, // 姓名
        positionalTitles: null, // 职称
        certificateName: null, // 证书名称
        level: null, // 级别
        number: null, // 证号
        professional: null, // 专业
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 直接发包备案表主键
      contractRecordDirectlyId: null,
      // 操作标志
      controllerFlg: null,
    }
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 如果是详情
      if (this.controllerFlg == "detail") {
        // 获取详情信息
        this.fun_GetDetail();
        // 遍历表单
        this.formConfigList.map(e => {
          // 遍历
          e.formConfigList.map(form => {
            // 不可编辑
            form.disabled = true;
          });
        });
      }
      // 如果是修改
      else if (this.controllerFlg == "update") {
        // 获取详情信息
        this.fun_GetDetail();
        // 遍历表单
        this.formConfigList.map(e => {
          // 遍历
          e.formConfigList.map(form => {
            // 可编辑
            form.disabled = false;
          });
        });
      }
      // 如果是新增
      else{
        // 遍历错误消息
        for (let i in this.form) {
          // 设置为空
          this.form[i] = null;
        }
        // 遍历表单
        this.formConfigList.map(e => {
          // 遍历
          e.formConfigList.map(form => {
            // 可编辑
            form.disabled = false;
          });
        });
      }
    },
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_PostAction("/organizationAllocation/detail", {
        id: this.id,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 确定
     */
    fun_Submit(){
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 新增修改
          this.fun_SaveOrUpdate();
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 新增修改
     */
    fun_SaveOrUpdate(){
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("/organizationAllocation/saveOrUpdate", {
        ...this.form,
        id: this.id, // 主键
        contractRecordDirectlyId: this.contractRecordDirectlyId, // 直接发包备案表主键
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.fun_Back();
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回
     */
    fun_Back(){
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面数据
        this.$parent.$parent.fun_GetList();
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}